export default __webpack_public_path__ + "static/media/ei-logo-white.0536ca53.png";